import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'es_ES',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '2fee61ff-1f48-4971-bc6a-0a648755e34a',
  ''
);
